import { cn } from '@/lib/utils'

export function SmoothBevelContainer({
  children,
  className
}: {
  children: React.ReactNode
  className?: string
}): React.ReactNode {
  return (
    <div
      className={cn(
        'shadow-subtle px-sm py-xs rounded-xs border-outline-variant h-16 border [background:var(--soft-bevel-gradient)]',
        className
      )}
    >
      {children}
    </div>
  )
}
